// 防伪码
export default [

  {
    path: '/securityCode',
    component: () => import('@/pages/securityCode/securityCode.vue'),
    meta: {
      title: '防伪码查询',
    },
  },

];
